// export const apiUrl = 'http://114.29.239.77:9012' // demo
// export const apiUrl = 'https://delphys7-app.online' // dj
// export const apiUrl = 'https://delphys7-fi.online' // megasoft
// export const apiUrl = 'https://localhost:44368'
// export const apiUrl = 'http://192.168.20.109:1123'

export const apiUrl = 'https://delphys7-demo.online' // JMI
// export const apiUrl = 'https://delphys7-fi.online' // megasoft